import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { Report } from '../../../interfaces/report.interface';
import { GetReportsResponse } from '../interfaces/get-reports';
import { GetReportResponse } from '../interfaces/get-report';

export interface ReportsState {
  reports: Report[];
  report: Report | null;
  errorCode: number | null;
}

const initialState: ReportsState = {
  reports: [],
  report: null,
  errorCode: null,
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    getReportsInitApiAction: (state) => {
      state.errorCode = null;
    },
    getReportsSuccessApiAction: (state, action: PayloadAction<GetReportsResponse>) => {
      state.reports = action.payload.reports;
    },
    getReportsFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    getReportInitApiAction: (state) => {
      state.errorCode = null;
    },
    getReportSuccessApiAction: (state, action: PayloadAction<GetReportResponse>) => {
      state.report = action.payload.report;
    },
    getReportFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    reportsClearAction: (state) => {
      state.reports = [];
      state.report = null;
      state.errorCode = null;
    },
  },
});

export const {
  getReportsInitApiAction,
  getReportsSuccessApiAction,
  getReportsFailureApiAction,
  getReportInitApiAction,
  getReportSuccessApiAction,
  getReportFailureApiAction,
  reportsClearAction,
} = reportsSlice.actions;

export default reportsSlice.reducer;
